import request from "./client";

export const getTechnicians = async () => {
  const resp = await request.get("/v1/users?role=technician");
  return resp.body.results;
};

export const getAll = async () => {
  const resp = await request.get("/v1/users");
  return resp.body.results;
};

export const getRoles = async () => {
  const resp = await request.get("/v1/roles");
  return resp.body.results;
};

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/users/${id}`);
  return { data: resp.body };
};

export const getSome = async ({ q = "", limit = 10, offset = 0, sort_by = "name", sort_dir = "asc", role = "" }) => {
  try {
    const query = new URLSearchParams({
      limit,
      offset,
      sort_by,
      sort_dir,
      ...(q && { q }),
      ...(role && { role }),
    }).toString();
    const resp = await request.get(`/v1/users?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};

export const createOne = async ({ name, username, email, active, number, role_ids }) => {
  try {
    const resp = await request.post("/v1/users").send({
      name,
      username,
      email,
      active,
      number,
      role_ids,
    });
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const sendResetPassword = async ({ id }) => {
  try {
    await request.post(`/v1/users/${id}/send_reset_password`);
    return { error: null };
  } catch (e) {
    if (!e.response) {
      return { error: e };
    }
    return { error: e.response.body };
  }
};

export const resetPassword = async ({ id }) => {
  try {
    const resp = await request.post(`/v1/users/${id}/reset_password`);
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};

export const updateOne = async ({ id, name, username, email, active, number, role_ids }) => {
  try {
    const resp = await request.put(`/v1/users/${id}`).send({
      name,
      username,
      email,
      active,
      number,
      role_ids,
    });
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response.body };
  }
};
